import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import InvoiceStatus from "./InvoiceStatus";

export default class UpdateInvoiceStatusRequest extends BaseUpdateRequest {
    status: InvoiceStatus = InvoiceStatus.Deleted;
}
